import React from 'react';

import cx from 'classnames';

import s from './Loader.module.css';

interface LoaderProps {
    variant: 'light' | 'dark';
}

export const Loader = ({ variant = 'dark' }: LoaderProps) => (
    <div className={cx(s.loaderWrapper, s[variant])}>
        <div className={s.spinner}>
            <div className={s.bounce1} />
            <div className={s.bounce2} />
            <div className={s.bounce3} />
        </div>
    </div>
);
